import { Controllers } from 'lib/enums/routes/_controllers';
import { RevenueStructuresRoutes } from 'lib/enums/routes/revenue-structures';
import {
  RevenueStructureDoc,
  RevenueStructureWhole,
} from 'lib/interfaces/database/revenue-structure';
import { BaseService } from 'services/_base';

export class RevenueStructuresService extends BaseService {
  private static instance: RevenueStructuresService;

  static getInstance(): RevenueStructuresService {
    if (!RevenueStructuresService.instance) {
      RevenueStructuresService.instance = new RevenueStructuresService();
    }

    return RevenueStructuresService.instance;
  }

  private constructor() {
    super({
      controller: Controllers.revenueStructures,
    });
  }

  search(payload: Partial<RevenueStructureDoc>) {
    return this.POST(
      {
        uri: RevenueStructuresRoutes.Search,
      },
      payload
    )
      .then((result: RevenueStructureWhole[]) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  create(payload: Partial<RevenueStructureDoc>) {
    return this.POST(
      {
        uri: RevenueStructuresRoutes.CreateOne,
      },
      payload
    )
      .then((result: RevenueStructureWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }

  update(id: string, payload: Partial<RevenueStructureDoc>) {
    return this.PUT(
      {
        uri: `${RevenueStructuresRoutes.UpdateOne}/${id}`,
      },
      payload
    )
      .then((result: RevenueStructureWhole) => {
        return result;
      })
      .catch((error) => {
        console.error(error);
        return undefined;
      });
  }
}
